interface SelectProps {
  value: string;
  label: string;
}

export enum EventResponse {
  INSCRIPTIONS = 'SUBSCRIBED',
  WORKSHOPS = 'WORKSHOPS',
  CONFERENCES = 'CONFERENCES',
  ACTIVITIES = 'ACTIVITIES'
}

export enum WaintingListStatus {
  IN_WAITING_LIST = 'LE',
  ENABLED_TO_WAITING_LIST = 'HL',
  REGISTERED = 'IN',
  ENABLED_TO_REGISTER = 'VD'
}

export const CATEGORIES: string[] = [
  'Inscritos',
  'Talleres',
  'Conferencias',
  'Actividades'
];

export const DAYS_OF_WEEK: string[] = [
  'Lun',
  'Mar',
  'Mie',
  'Jue',
  'Vie',
  'Sab',
  'Dom'
];

export const WORKSHOPS_OPTIONS: SelectProps[] = [
  {
    value: 'Todos',
    label: 'Todos'
  },
  {
    value: 'Culturales',
    label: 'Culturales'
  },
  {
    value: 'Deportivos',
    label: 'Deportivos'
  },
  {
    value: 'Herramientasprofesionales',
    label: 'Herramientas profesionales'
  }
];

export const CONFERENCES_OPTIONS: SelectProps[] = [
  {
    value: 'Todos',
    label: 'Todos'
  },
  {
    value: 'Académico',
    label: 'Académico'
  },
  {
    value: 'Bienestar',
    label: 'Bienestar'
  },
  {
    value: 'Empleabilidad',
    label: 'Empleabilidad'
  },
  {
    value: 'Internacional',
    label: 'Internacional'
  },
  {
    value: 'Otros',
    label: 'Otros'
  }
];

export const ACTIVITIES_OPTIONS: SelectProps[] = [
  {
    value: 'Todos',
    label: 'Todos'
  }
];
